import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { documentFileSearch, documentsSearch, fetchFosaMedicalItemsPrice, fetchHealthFacilities } from '../../action';
import { useDispatch, useSelector } from 'react-redux';
import CommonCard from '../../reusableComponents/components/generics/CommonCard';
import { Grid } from '@mui/material';
import {useNavigate} from "react-router-dom";
import { bankOptions, MEDICAL_ITEMS, MEDICAL_SERVICES } from '../../utils/constant';

export default function HealthFacilitiesDetails({ handleDocumnetView }) {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const SignInSuccess = useSelector((state) => state);
    const documentData = useSelector((state) => state.profileReducer?.documentData);
    const navigate = useNavigate();


    let healthData;

    useEffect(() => {
        if (SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]?.fosaCode) {
            dispatch(documentsSearch({ requestNumber: `${SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]?.fosaCode}` }));
            dispatch(documentFileSearch({ requestNumber: `${SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]?.fosaCode}` }))
        }
    }, [SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]])

    const labels = [
        ("F-Code"),
        ("CAMUCode"),
        ("ConventionnementCode"),
        ("FOSAName"),
        ("FOSACategory"),
        ("FOSAType"),
        ("Department"),
        ("City"),
        ("Muncipality"),
        ("Village"),
        ("LegalForm"),
        ("CareType"),
        ("Address"),
        ("Phone1"),
        ("Phone2"),
        ("AuthorizationDate"),
        ("Manager"),
        ("MSPApprovalNo."),
        ("NIU"),
        ("CNSSNo"),
        ("RCCM"),
        ("TaxMoralityCertificate"),
        ("HealthDistrict"),
        ("Latitude"),
        ("Longitude"),
        ("ContactPerson"),
        ("ContactPersonPhone"),
    ];


  

    const labelsBank = [
        ("BankName"),
        ("BankCode"),
        ("BankLockerCode"),
        ("BankA/CNo"),
        ("RIBKey"),
    ]

    const labelsPriceList = [
        ("ServicesPriceList"),
        ("ItemsPriceList")
    ]



    const getBankVal = (val) => {
        const bankLabel = bankOptions.find((bank) => bank.value == val);
        return bankLabel ? bankLabel.label : "";
    };


    const getLegalForm = (value) => {
        switch (value) {
            case '1':
                return 'Association/ Syndicat   ';
            case '2':
                return 'SA/ SAU/ SAS'
            case '3':
                return 'Confession religieuse'
            case '4':
                return 'Collectivité publique'
            case '5':
                return 'Coopérative/ Société mutualiste/ GIE'
            case '6':
                return 'Établissement individuel/ EURL'
            case '7':
                return 'Établissement public'
            case '8':
                return 'Fondation/ ONG'
            case '9':
                return 'Organisation Internationale/ Représentation diplo'
            case '10':
                return 'SARL/ SARLU'
            case '10':
                return 'Autre'
            default:
                return 'Association/ Syndicat'
        }
    }


    const getCareTYpe = (value) => {
        switch (value) {
            case 'I':
                return 'In - Patient';
            case 'O':
                return 'Out- Patient'
            case 'B':
                return 'In & Out - Patient'
        }
    }

  
    const generalValues = (label) => {
        healthData = SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0];
       

        let jsonObject;
        if (healthData?.jsonExt) {
            jsonObject = JSON.parse(healthData?.jsonExt);
        }
        switch (label) {
            case 'F-Code':
                return healthData?.fosaCode;
                break;
            case 'CAMUCode':
                return jsonObject?.camuCode;
                break;
            case 'ConventionnementCode':
                return jsonObject?.conventionnement;
                break;
            case 'FOSAName':
                return healthData?.name
            case 'FOSACategory':
                return healthData?.category?.label;
                break;
            case 'FOSAType':
                return jsonObject?.type;
                break;
            case 'Department':
                return `${jsonObject?.department_code} ${jsonObject?.location?.parent?.parent.parent.name}` ;
                break;
            case 'City':
                return jsonObject?.location?.parent?.parent?.name;
                break;
            case 'Muncipality':
                return jsonObject?.location?.parent?.name;
                break;
            case 'Village':
                return jsonObject?.location.name;
                break;
            case 'LegalForm':
                return getLegalForm(healthData?.legalForm);
                break;
            case 'CareType':
                return getCareTYpe(healthData?.careType);
                break;
            case 'Address':
                return healthData?.address;
                break;
            case 'Phone1':
                return healthData?.phone;
                break;
            case 'Phone2':
                return jsonObject?.phone2;
                break;
            case 'AuthorizationDate':
                return jsonObject?.creationDate;
                break;
            case 'Manager':
                return jsonObject?.responsibleName;
                break;
            case 'MSPApprovalNo.':
                return jsonObject?.approvalNumber;
                break;
            case 'NIU':
                return jsonObject?.niuNo;
                break;
            case 'CNSSNo':
                return jsonObject?.cnssNumber;
                break;
            case 'RCCM':
                return jsonObject?.RCCM;
                break;
            case 'TaxMoralityCertificate':
                return jsonObject?.taxMoralityCertificate;
                break;
            case 'HealthDistrict':
                return jsonObject?.healthDistrict;
                break;
            case 'Latitude':
                return jsonObject?.latitude;
                break;
            case 'Longitude':
                return jsonObject?.longitude;
                break;
            case 'ContactPerson':
                return jsonObject?.contactFirstNames;
                break;
            case 'ContactPersonPhone':
                return jsonObject?.contactPhone;
                break;
            case 'BankName':
                // return getBankVal(jsonObject?.name);
                return jsonObject?.bank?.name;
                break;
            case 'BankCode':
                return jsonObject?.bankCode?.code;
                break;
            case 'BankLockerCode':
                return jsonObject?.lockerCode;;
                break;
            case 'BankA/CNo':
                return jsonObject?.accountNb;
                break;
            case 'RIBKey':
                return jsonObject?.bankKey;
                break;
            case 'ServicesPriceList':
                return healthData?.servicesPricelist?.name;
                break;
            case 'ItemsPriceList':
                return healthData?.itemsPricelist?.name;
                break;
            default:

                break;
        }
    };

    const getListLink = (label) => {
        switch (label) {
            case 'ItemsPriceList':
                return MEDICAL_ITEMS;
                break;
            case 'ServicesPriceList':
                return MEDICAL_SERVICES;
                break;
            default:
                break;
        }
    }

    const data =    labels.map((label) => ({
        label: t(label),
        value: generalValues(label)
    }));


    const dataBank = labelsBank.map((label) => ({
        label: t(label),
        value: generalValues(label)
    }));

    const dataPricelsit = labelsPriceList.map((label) => ({
        label: t(label),
        value: generalValues(label),
        onClick: () => {
            navigate(getListLink(label))
        },
    }));


    const data3 = documentData
        ? documentData.map((doc) => ({
            label: t(doc.documentName),
            value: doc.documentPath,
            onClick: () => handleDocumnetView && handleDocumnetView(doc),
        }))
        : [];



 
    return (
        <Grid container>
            <CommonCard headerTitle={t("General Information")} data={data} />
            <CommonCard headerTitle={t("Bank Details")} data={dataBank} />
            <div style={{ display: 'flex', width: '100%' }}>
                <CommonCard headerTitle={t("Price List")} data={dataPricelsit} itemsPerRow={1} />
                <CommonCard headerTitle={t("Documents")} data={data3} itemsPerRow={1}/>
            </div>
        </Grid>
    )
}
